const AUDIOEYE_LAUNCHER_ID = "ae_launcher";
const AUDIOEYE_LAUNCHER_SELECTOR = `#${AUDIOEYE_LAUNCHER_ID}`;
const AUDIOEYE_TRIGGER_SELECTOR = `${AUDIOEYE_LAUNCHER_SELECTOR} button`;
const AUDIOEYE_HIDE_STYLE_ID = "televeda-audioeye-hide-launcher";

function forceHideLauncher() {
    var launcher = document.getElementById(AUDIOEYE_LAUNCHER_ID);
    if (launcher) {
        launcher.style.setProperty("display", "none", "important");
    }
}

export function loadAudioEyeScript() {
    if (!document.getElementById(AUDIOEYE_HIDE_STYLE_ID)) {
        var style = document.createElement("style");
        style.id = AUDIOEYE_HIDE_STYLE_ID;
        style.textContent = AUDIOEYE_LAUNCHER_SELECTOR + " { display: none !important; }";
        document.head.appendChild(style);
    }

    forceHideLauncher();
    var persistentObserver = new MutationObserver(forceHideLauncher);
    persistentObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "class"],
    });

    window.__AudioEyeSiteHash = "f733a500a8be35f38b6a3743b667eabb";
    var a = document.createElement("script");
    a.src = "https://wsmcdn.audioeye.com/aem.js";
    a.type = "text/javascript";
    a.setAttribute("async", "");
    document.getElementsByTagName("body")[0].appendChild(a);
}

export function openAudioEyeMenu() {
    var trigger = document.querySelector(AUDIOEYE_TRIGGER_SELECTOR);
    if (trigger) {
        trigger.click();
        return;
    }

    var observer = new MutationObserver(function () {
        var lateTrigger = document.querySelector(AUDIOEYE_TRIGGER_SELECTOR);
        if (lateTrigger) {
            lateTrigger.click();
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 5000);
}
